import { Inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BackendService } from './backend.service';
import { Barcodes, Cart, CashBox, Settings } from './models';
import { APP_SETTINGS } from './settings-data.provider';
import SPaymentPOS from '../../plugins/s-payment-pos';


interface ApplicationState {
  cart: Cart;
  barcodes: { [key: string]: number };
  cashBox: CashBox;
}

@Injectable({ providedIn: 'root' })
export class AppStateLoaderService {
  data: ApplicationState | null = null;
  private ready: Promise<boolean> | null = null;
  private _updated = new Subject<void>();
  updated = this._updated.asObservable();

  constructor(@Inject(APP_SETTINGS) private readonly settings: Settings,
    private readonly backendService: BackendService) {
  }

  loaded(): Promise<boolean> {
    if (this.ready === null) {
      this.ready = this.loadState();
    }

    return this.ready;
  }

  private async loadState(): Promise<boolean> {
    const [cart, barcodes, cashBox]: [Cart, Barcodes, CashBox] = await Promise.all([
      this.backendService.fetchCart(),
      this.backendService.fetchBarcodes(),
      this.backendService.fetchCashBox(this.settings.posUuid)
    ]);

    this.data = { cart, barcodes, cashBox };
    await this.initializeSPaymentPOS(this.settings);
    this._updated.next();
    return true;
  }

  async initializeSPaymentPOS(settings: Settings): Promise<boolean> {
    const appId = settings.sPaymentPosAppId;
    if (!appId) {
      console.info('S-Payment POS App ID not provided, skipping initialization...');
      return false;
    }
    try {
      const { isAvailable } = await SPaymentPOS.startSwitchMode({
        appId: appId,
      });
      return isAvailable;
    } catch (error: any) {
      // on the desktop version plugins are not supported and Capacitor throws an exception
      if (error.code === 'UNIMPLEMENTED') {
        return false;
      }
      console.error(error.message, error.code, error);
      return false;
    }
  }

  clear() {
    this.ready = null;
    this.data = null;
  }
}
